import React from "react";
import { Check } from "lucide-react";
import { ikonaTypu } from "../lib/typyAktivit";
import { fmtTime } from "../lib/format";

/**
 * Jeden řádek aktivity pro karty klienta, případu i zařízení (plátno 14B):
 * ikona typu · datum s časem · název a kdo · štítek stavu · kulaté odškrtnutí.
 * `kompakt` = úzký sloupec (případ vpravo): bez ikony a štítku, ať se vejde název.
 */
const STITEK = {
  po: { text: "Po termínu", cls: "text-danger bg-[#fdeeec]" },
  hotovo: { text: "Hotovo", cls: "text-success bg-success-bg" },
  // Modrá, ne jantarová — v kalendáři platí „barva = stav" a otevřené je modré.
  otevrene: { text: "Otevřené", cls: "text-[#2c6ecb] bg-[#eef4fd]" },
};

function denMesic(iso) {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : `${d.getDate()}. ${d.getMonth() + 1}.`;
}

export default function RadekAktivity({ a, onOpen, onToggle, kompakt = false }) {
  const hotova = a.stav === "HOTOVA";
  const stav = hotova ? "hotovo" : a.po_terminu ? "po" : "otevrene";
  const Ikona = ikonaTypu(a.typ);
  const kdo = (a.osoby || []).map((o) => o.name).filter(Boolean)[0] || (a.osoby_jmena || [])[0];
  const meta = [a.typ, a.zarizeni_nazev, kdo].filter(Boolean).join(" · ");

  return (
    <div onClick={onOpen} role="button" tabIndex={0} data-testid={`activity-${a.id}`}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onOpen(); } }}
      className={`flex items-center gap-3 md:gap-3.5 px-4 md:px-5 py-3 border-b border-line-soft last:border-0 cursor-pointer hover:bg-inputbg ${
        a.po_terminu && !hotova ? "bg-[#fdf8f7]" : ""}`}>
      {!kompakt && (
        <span className={`h-9 w-9 rounded-[12px] inline-flex items-center justify-center shrink-0 ${
          hotova ? "bg-success-bg text-success" : a.po_terminu ? "bg-[#fdeeec] text-danger" : "bg-inputbg text-sec"}`}>
          <Ikona size={16} strokeWidth={1.9} />
        </span>
      )}
      <span className="w-[52px] md:w-[60px] shrink-0">
        <span className={`block amount t-meta md:text-[13px] font-700 ${a.po_terminu && !hotova ? "text-danger" : "text-ink"}`}>{denMesic(a.date_start)}</span>
        <span className="block amount text-[11px] text-muted">{fmtTime(a.date_start)}</span>
      </span>
      <span className="min-w-0 flex-1">
        <span className={`block t-telo md:text-[14px] font-600 truncate ${hotova ? "text-muted line-through" : "text-ink"}`}>{a.nazev}</span>
        {meta && <span className="block t-meta text-muted truncate">{meta}</span>}
      </span>
      {!kompakt && <span className={`hidden sm:inline-flex label-up px-2.5 py-1 rounded-pill shrink-0 ${STITEK[stav].cls}`}>{STITEK[stav].text}</span>}
      {onToggle && (
        <button type="button" onClick={(e) => { e.stopPropagation(); onToggle(); }} data-testid={`toggle-${a.id}`}
          title={hotova ? "Vrátit mezi otevřené" : "Označit hotové"} aria-label={hotova ? "Vrátit mezi otevřené" : "Označit hotové"}
          className={`tap md:min-h-0 md:min-w-0 h-[30px] w-[30px] rounded-full flex items-center justify-center shrink-0 transition-colors ${
            hotova ? "bg-success text-white" : "shadow-[inset_0_0_0_1.5px_#d5d3ce] text-transparent hover:shadow-[inset_0_0_0_1.5px_#17876a] hover:text-success"}`}>
          <Check size={15} strokeWidth={2.6} />
        </button>
      )}
    </div>
  );
}
